document.addEventListener('DOMContentLoaded', function() {
  // Target Horizon product elements
  const productCards = document.querySelectorAll('.product-card, .card-wrapper');
  
  productCards.forEach((card, index) => {
    const productTitle = card.querySelector('.product-title, .card__heading, h3');
    if (!productTitle) return;  // Skip if no title
    
    const productHandle = productTitle.textContent.toLowerCase().replace(/\s+/g, '-');  // Simple handle from title
    const productTags = [];  // Fetch tags via Shopify API or assume from data attribute; for demo, simulate based on title
    
    // Simulate tags for demo (replace with real fetch if needed, e.g., via AJAX to /products/{handle}.json)
    if (productTitle.textContent.toLowerCase().includes('sale')) productTags.push('sale');
    if (productTitle.textContent.toLowerCase().includes('new')) productTags.push('new');
    if (productTitle.textContent.toLowerCase().includes('limited')) productTags.push('low-stock');
    
    // Add badges based on tags
    productTags.forEach(tag => {
      const badge = document.createElement('span');
      badge.className = `badge badge--${tag}`;
      badge.textContent = tag.toUpperCase();
      badge.setAttribute('aria-label', `${tag} item`);
      card.querySelector('.product-card__image-wrapper, .card__media')?.appendChild(badge);
    });
    
    // Add stock bar (e.g., 80% for full, 30% for low-stock)
    if (productTags.includes('low-stock')) {
      const stockBar = document.createElement('div');
      stockBar.className = 'stock-indicator';
      const stockFill = document.createElement('div');
      stockFill.className = 'stock-fill';
      stockFill.style.width = '30%';  // Low stock visual
      stockBar.appendChild(stockFill);
      card.querySelector('.card__content, .product-card__inner')?.appendChild(stockBar);
      
      // Add alert
      const alert = document.createElement('div');
      alert.className = 'stock-alert';
      alert.textContent = 'Low Stock!';
      alert.setAttribute('aria-label', 'Low stock available');
      card.appendChild(alert);
    } else {
      // Default full stock for others
      const stockBar = document.createElement('div');
      stockBar.className = 'stock-indicator';
      const stockFill = document.createElement('div');
      stockFill.className = 'stock-fill';
      stockFill.style.width = '100%';
      stockBar.appendChild(stockFill);
      card.querySelector('.card__content, .product-card__inner')?.appendChild(stockBar);
    }
    
    // Staggered entrance animation
    card.style.animationDelay = `${index * 0.1}s`;
    card.classList.add('animate-in');  // Trigger CSS animation
  });
});